import moment from 'moment-timezone/moment-timezone';
import { Callout, Checkbox, Icon } from 'office-ui-fabric-react';
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { WsDeliverConfigResourceItem, WsDeliverTenantInterface } from "../../../../../core/src/interfaces";

import { apiGet } from "../../../helpers-sales";

import { Loading } from "../../Shared";

import { WsDemoDialogDiff } from "./DemoDialogDiff";

import { getDiff, getDiffList, getParentPath, getResourceItemFromList, getResourceName, WsResourceDiff } from "../data/deliver-data";




import './Demo.scss';




const configHistory = [
  '2024-09-05',
  '2024-08-28',
  '2024-08-21',
  '2024-08-14',
  '2024-08-07',
  '2024-08-05',
  '2024-07-31',
  '2024-07-25',
  '2024-07-15',
  '2024-07-12',
  '2024-07-08',
  '2024-07-05',
  '2024-07-01',
  '2024-06-28',
  '2024-06-24',
  '2024-06-21',
  '2024-06-17',
  '2024-06-14',
  '2024-06-10',
  '2024-06-07',
  '2024-06-03'
];




let consoleTimeStart = 0;

const consoleTime = (tag: string, start?: boolean) => {

  if (start) {
    consoleTimeStart = Date.now();
    console.log(`time : ${tag} : start`);
  } else {
    console.log(`time : ${tag} : ${Date.now() - consoleTimeStart}`);
  }
};




const WsConfigItem = (props: {
  configResourceTree: WsDeliverConfigResourceItem[];
  configResourceItem: WsDeliverConfigResourceItem;
  index: number;

  expandedPaths: string[];
  setExpanded: (value: boolean) => void;

  // onClick: (event: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>) => void;

  showValues?:  boolean;
  showStatus?:  boolean;
  showHistory?: boolean;
  compareConfigResourceTree: WsDeliverConfigResourceItem[] | undefined;
  compareTenantName?: string;
  diffList: WsResourceDiff[];
}) => {

  const currentLocation = useLocation();

  const resourceHasChildren = props.configResourceTree.filter((item) => item.path.startsWith(props.configResourceItem.path) && item.path !== props.configResourceItem.path).length > 0;

  const resourceIsExpanded = props.expandedPaths.includes(props.configResourceItem.path);


  const [ checked, setChecked ] = useState<boolean>(true);

  const resourceColumns: JSX.Element[] = [];



  // diff count

  let diffCount = 0;

  if (props.compareConfigResourceTree) {
    diffCount = getDiff(props.configResourceItem.path, props.diffList);
  }



  // compare

  if (props.compareConfigResourceTree) {



    // target resource item

    const targetResourceItem = getResourceItemFromList(props.configResourceItem.path, props.compareConfigResourceTree);



    // source value

    resourceColumns.push(
      <Fragment key={`ws-value-right-${props.index}-${props.configResourceItem.name}-compare-source`}>
        {/* <td key={`ws-value-left-${props.index}-${props.configResourceItem.name}-current`}>
          {
            hasChildren
            ?
            <></>
            :
            <>{`${props.configResourceItem.value}`}</>
          }
        </td> */}

        <WsConfigResourceTableCellWithDiff
          configResourceItem={props.configResourceItem}
          showValue={resourceHasChildren ? false : true}
          diff={diffCount}
          date={''}
        />
      </Fragment>
    );



    // target value

    resourceColumns.push(
      <Fragment key={`ws-value-right-${props.index}-${props.configResourceItem.name}-compare-target`}>
        {/* {
          hasChildren
          ?
          <>
            {
              diff > 0
              &&
              <>
                [{diff}]
              </>
            }
          </>
          :
          <>{`${targetResourceItem?.value}`}</>
        }
        <td
          className={ diff > 0 ? 'ws-configuration-item-diff-red' : '' }
        >
          
        </td> */}

        <WsConfigResourceTableCellWithDiff
          configResourceItem={targetResourceItem}
          showValue={resourceHasChildren ? false : true}
          diff={diffCount}
          date={''}
        />

        {
          currentLocation.pathname.indexOf('/compare/') < 0
          &&
          <td>
            {
              diffCount > 0
              &&
              <Checkbox
                // label="OUT"
                checked={checked}
                onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement> | undefined, checkedValue?: boolean | undefined) => {
                  setChecked(!checked);
                }}
                // disabled={currentStep === 6}
                // disabled={diffCount === 0}
              />
            }
          </td>
        }

      </Fragment>
    );



  } else {

    // current value

    resourceColumns.push(
      <td key={`ws-value-${props.index}-${props.configResourceItem.name}-current`}>
        {
          resourceHasChildren
          ?
          <></>
          :
          <>{`${props.configResourceItem.value}`}</>
        }
      </td>
    );
  }



  // history

  if (props.showHistory) {

    configHistory.slice(1).forEach((date: string, dateIndex: number) => {

      if (
        props.index > 10000 &&
        props.index % 5 === 1 &&
        dateIndex % 5 === 1
      ) {

        resourceColumns.push(
          <Fragment key={`ws-x-${dateIndex}-${props.configResourceItem.name}-item-diff`}>
            {/* <WsConfigResourceTableCellWithDiff
              configResourceItem={props.configResourceItem}
              showValue={false}
              diff={1}
              date={date}
            /> */}
            <td
              key={`ws-x-${dateIndex}-${props.configResourceItem.name}-item`}
              className="ws-configuration-item-diff"
            ></td>
          </Fragment>
        );

      } else {

        resourceColumns.push(
          <td
            key={`ws-x-${dateIndex}-${props.configResourceItem.name}-item`}
            // className="ws-configuration-item-diff"
          ></td>
        );
      }

    });
  }



  // level

  let level = props.configResourceItem.path.split('/').length - 4;

  if (level < 0) {
    level = 0;
  }



  // padding

  const paddingLeft = 9 + (level * 21);



  // render

  return (
    <Fragment>
      <tr>
        {
          resourceHasChildren
          ?
          <td
            className={diffCount > 0 ? 'ws-configuration-category ws-configuration-item-diff-cell' : 'ws-configuration-category'}
            style={{ paddingLeft: `${paddingLeft + 21}px` }}
            onClick={() => {
              props.setExpanded(!resourceIsExpanded);
            }}
          >
            {
              resourceIsExpanded
              ?
              <>
                <Icon
                  iconName={'CollapseContentSingle'}
                  className="ws-deliver-config-collapsed"
                  style={{ left: `${paddingLeft}px` }}
                />
                {getResourceName(props.configResourceItem)}
              </>
              :
              <>
                <Icon
                  iconName={'ExploreContentSingle'}
                  className="ws-deliver-config-expanded"
                  style={{ left: `${paddingLeft}px` }}
                />
                {getResourceName(props.configResourceItem)}
                {
                  diffCount > 0
                  &&
                  <div className="ws-configuration-item-diff-badge">
                    <Icon className="ws-configuration-item-diff-icon" iconName={'Warning'} />
                    <div className="ws-configuration-item-diff-count">{diffCount}</div>
                  </div>
                }
              </>
            }
          </td>
          :
          <td
            className={diffCount > 0 ? 'ws-configuration-item ws-configuration-item-diff-cell' : 'ws-configuration-item'}
            style={{ paddingLeft: `${paddingLeft + 21}px` }}
          >
            {getResourceName(props.configResourceItem)}
            {
              diffCount > 0
              &&
              <div className="ws-configuration-item-diff-badge">
                <Icon className="ws-configuration-item-diff-icon" iconName={'Warning'} />
              </div>
            }
          </td>
        }

        {resourceColumns}

      </tr>

    </Fragment>
  );
};




const WsConfigHistory = (props: {
  tenant: WsDeliverTenantInterface;
  workload: string;
  dataType: string;
  showValues?:  boolean;
  showStatus?:  boolean;
  showHistory?: boolean;
  compareTenant?: WsDeliverTenantInterface;
  compareTenantName?: string;
}) => {

  const currentLocation = useLocation();

  // const params: { tenantType: string, tenantId: string, compareTenantId?: string, workload?: string } = useParams();





  // diff

  // const dialogDiffRef = useRef<WsDemoDialogDiff>() as React.RefObject<WsDemoDialogDiff>;

  // const onClick = (event: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>) => {
  //   if (dialogDiffRef.current) {
  //     dialogDiffRef.current.show(event.currentTarget.dataset.selectedDate, event.currentTarget.dataset.selectedCategory, event.currentTarget.dataset.selectedItem);
  //   }
  // };



  // state

  const [ configResourceTree, setConfigResourceTree ] = useState<WsDeliverConfigResourceItem[] | undefined>(undefined);

  const [ compareConfigResourceTree, setCompareConfigResourceTree ] = useState<WsDeliverConfigResourceItem[] | undefined>(undefined);

  const [ diffList, setDiffList ] = useState<WsResourceDiff[]>([]);



  // expanded paths

  const [ expandedPaths, setExpandedPaths ] = useState<string[]>([ '/DSC/', '/PowerShell/' ]);

  useEffect(() => {
    // console.log(expandedPaths);
  }, [ expandedPaths ]);



  // load data

  useEffect(() => {

    setConfigResourceTree(undefined);
    setCompareConfigResourceTree(undefined);
    setDiffList([]);

    setTimeout(async () => {


      // tenant

      const result = await apiGet(`/deliver/${props.tenant.azureTenantId}/${props.workload}/resource-data${( props.dataType ? `?type=${props.dataType}` : '')}`);

      if (result && Array.isArray(result)) {
        const resultData = result as WsDeliverConfigResourceItem[];
        // console.log(resultData);
        // consoleTime('load data', true);
        setConfigResourceTree(resultData);


        // compare

        if (props.compareTenant) {

          const compareResult = await apiGet(`/deliver/${props.compareTenant.azureTenantId}/${props.workload}/resource-data${( props.dataType ? `?type=${props.dataType}` : '')}`);

          if (compareResult && Array.isArray(compareResult)) {
            const compareResultData = compareResult as WsDeliverConfigResourceItem[];
            // console.log(compareResultData);
            setCompareConfigResourceTree(compareResultData);

            const diffListResult = getDiffList(resultData, compareResultData);
            // console.log(diffListResult);
            setDiffList(diffListResult);
          }
        }
      }

    }, 200);

  }, [ props.tenant, props.workload, props.compareTenant, props.dataType ]);



  let action = '';

  if (currentLocation.pathname.indexOf('/compare/') > -1) {
    action = 'COMPARE';
  }

  if (currentLocation.pathname.indexOf('/clone/') > -1) {
    action = 'CLONE';
  }

  if (currentLocation.pathname.indexOf('/restore/') > -1) {
    action = 'RESTORE';
  }



  // render

  if (configResourceTree && (props.compareTenant ? compareConfigResourceTree : true)) {



    // columns

    const listColumns: JSX.Element[] = [];

    configHistory.forEach((date: string, index: number) => {

      if (index === 0) {


        // compare

        if (props.compareTenant) {

          // left

          listColumns.push(
            <th key={`ws-x-${date}-column`}>
              {
                currentLocation.pathname.indexOf('/compare/') < 0
                ?
                <>Current Value ({props.tenant.name})</>
                :
                <>{props.tenant.name}</>
              }
            </th>
          );

          // right

          listColumns.push(
            <th key={`ws-y-${date}-column`}>
              {
                currentLocation.pathname.indexOf('/compare/') < 0
                ?
                <>Apply Value ({props.compareTenantName ? props.compareTenantName : props.compareTenant.name})</>
                :
                <>{props.compareTenantName ? props.compareTenantName : props.compareTenant.name}</>
              }
            </th>
          );

          if (currentLocation.pathname.indexOf('/compare/') < 0) {

            // apply

            listColumns.push(
              <th key={`ws-y-${date}-column-check`}>
              </th>
            );
          }


        } else {

          // current value

          listColumns.push(
            <th key={`ws-z-${date}-column`}>
              {
                props.showHistory
                ?
                <>
                  Current
                  <div className="ws-list-header-date">{moment(date).format('D')} {moment(date).format('MMM')}</div>
                </>
                :
                <>Configuration Value</>
              }
            </th>
          );

        }


      } else {

        // history

        if (props.showHistory) {

          listColumns.push(
            <th
              key={`ws-date-${date}-column`}
              className="ws-configuration-item-diff ws-configuration-item-diff-click"
              // onClick={onClick}
              data-selected-date={date}
              data-selected-category="" data-selected-item=""
            >
              W{moment(date).format('W')}
              <div className="ws-list-header-date">{moment(date).format('D')} {moment(date).format('MMM')}</div>
            </th>
          );
        }
      }
    });

    // consoleTime('columns');



    // rows

    const listItems: JSX.Element[] = [];

    configResourceTree.forEach((configResourceItem: WsDeliverConfigResourceItem, index: number) => {

      const resourcePath = configResourceItem.path;

      const resourceParentPath = getParentPath(resourcePath); // resourcePath.replace(`${encodeResourceName(configResourceItem.name)}/`, '');

      if (expandedPaths.includes(resourceParentPath)) {

        listItems.push(
          <Fragment key={`ws-config-item-${index}`}>
            <WsConfigItem
              configResourceTree={configResourceTree}
              configResourceItem={configResourceItem}
              index={index}

              expandedPaths={expandedPaths}
              setExpanded={(value: boolean) => {
                let nextExpandedPaths = [ ...expandedPaths ];

                if (value) {
                  nextExpandedPaths.push(resourcePath);
                } else {
                  nextExpandedPaths = nextExpandedPaths.filter((item) => !item.startsWith(resourcePath));
                }

                setExpandedPaths(nextExpandedPaths);
              }}

              showValues={props.showValues}
              showStatus={props.showStatus}
              showHistory={props.showHistory}
              compareConfigResourceTree={compareConfigResourceTree}
              compareTenantName={props.compareTenantName}
              diffList={diffList}
            />
          </Fragment>
        );
      }
    });

    // consoleTime('rows');



    // render

    const classList = [
      'table is-bordered is-hoverable is-fullwidth',
      'ws-configuration-list'
    ];

    if (props.compareTenant) {
      classList.push('ws-config-resource-table-compare');
    }

    return (
      <>
        <div className="ws-demo-page ws-scroll ws-scroll-x">
          <table className={classList.join(' ')}>
            <thead>
              <tr>
                <th></th>
                {listColumns}
              </tr>
            </thead>
            <tbody>
              {listItems}
            </tbody>
          </table>
        </div>
        {/* <WsDemoDialogDiff ref={dialogDiffRef} /> */}
      </>
    );

  } else {
    return (
      <>
        <Loading />
        <br />
        <br />
      </>
    );
  }
};




const WsConfigResourceTableCellWithDiff = (props: {
  configResourceItem: WsDeliverConfigResourceItem | undefined;
  showValue: boolean;
  date: string;
  diff: number;
}) => {

  const classList: string[] = [];

  if (props.showValue) {
    classList.push('ws-configuration-item-diff-value');

    if (props.diff > 0) {
      classList.push('ws-configuration-item-diff');
      // classList.push('ws-configuration-item-diff-click');
    }
  }

  if (props.diff > 0) {
    classList.push('ws-configuration-item-diff-cell');
  }

  return (
    <td
      className={classList.join(' ')}
      // onClick={props.onClick}
      data-selected-date={props.date}
      data-selected-category={props.configResourceItem?.name}
      data-selected-item=""
    >
      {
        props.showValue
        ?
        <>
          {
            props.diff
            ?
            <b>{props.configResourceItem ? `${props.configResourceItem.value}` : ''}</b>
            :
            <>{props.configResourceItem ? `${props.configResourceItem.value}` : ''}</>
          }
        </>
        :
        <>
          {
            props.diff > 0
            &&
            <>
              {/* <Icon className="ws-configuration-item-diff-icon" iconName={'Warning'} />
              <div className="ws-configuration-item-diff-count">{props.diff}</div> */}
            </>
          }
        </>
      }
    </td>
  );
};




export {
  WsConfigHistory
};
